<template>
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<script lang="js">

import axios from "axios";

export default {
  name: "App",
  created() {
    //Evitar que se pierda el token de sesión
    let token = window.sessionStorage.getItem("Token");
    if (token != null) {
      axios.defaults.headers.common["Authorization"] = token;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Poppins";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #b8725a;
}

/*Modificaciones al input para fechas. */
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 45px;
  padding: 0;
  max-height: 45px;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  border-radius: 0px;
  border: 0.9px solid #707070;
}

.v-icon.v-icon {
  color: #b8725a !important;
  border-radius: 50%;
}

@media all and (max-width: 767px) {
  .v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot {
    font-size: 13px;
  }
}
</style>
